import React from 'react';
import ScrollToTopBtn from "./scrollToTopButton";
import FooterUsefullMenu from './footerUsefullMenu';
import FooterInfoMenu from './footerInfoMenu';
import FooterAddressMenu from './footerAddressMenu';
import { Link } from 'react-router-dom';
import { inject, observer } from "mobx-react";
import CookiesModal from '../../modals/cookiesModal';
import "./Footer.css";
import CopyrightOutlinedIcon from '@mui/icons-material/CopyrightOutlined';
import arrow_appdate from '../../img/arrow-appdate.png';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import TwitterIcon from '@mui/icons-material/Twitter';
import googleButton from '../../img/Google-Play-Store-Button.png';
import TenantLogo from '../TenantLogo';
import {HIDE_APPDATE} from "../../assets/globalConstants";

// Translations
import _useTranslate from '../../hooks/_useTranslate';

const Footer = ({ feathersStore }) => {

    const footer = _useTranslate(feathersStore.language, "footer");

    const androidUrl = feathersStore.androidStoreUrl();
    const urlIos = feathersStore.iosStoreUrl();
    const imageIos = 'https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&amp;releaseDate=1625702400&h=756295c0d4e95f66799873c9eee485ea';

    const hasSocialMedia = feathersStore.settings?.facebookUrl ||
        feathersStore.settings?.instagramUrl ||
        feathersStore.settings?.youtubeUrl ||
        feathersStore.settings?.twitterUrl;


    return (
        <>
            {/* Main Footer - Green Section */}
            <footer className="footer">
                {/* Logo & Contact Section */}
                <div className="footer-logo-section">
                    <div className="footer-logo-row">
                    <Link className="footerLogo" to="/" aria-label="Home">
                        <TenantLogo
                            branding={feathersStore.branding}
                            className="logo"
                            squareClassName="logo-square"
                            loading="lazy"
                            decoding="async"
                        />
                    </Link>

                    <FooterAddressMenu />
                    </div>

                    {/* Social Media */}
                    {hasSocialMedia && (
                        <div className="footer-social">
                            <span className="footer-social-label">Follow us:</span>
                            <div className="footer-social-icons">
                                {feathersStore.settings?.facebookUrl && (
                                    <a
                                        aria-label="Facebook"
                                        href={feathersStore.settings.facebookUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="social-icon fb"
                                    >
                                        <FacebookIcon sx={{ fontSize: 28 }} />
                                    </a>
                                )}
                                {feathersStore.settings?.instagramUrl && (
                                    <a
                                        aria-label="Instagram"
                                        href={feathersStore.settings.instagramUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="social-icon"
                                    >
                                        <InstagramIcon sx={{ fontSize: 28 }} />
                                    </a>
                                )}
                                {feathersStore.settings?.youtubeUrl && (
                                    <a
                                        aria-label="YouTube"
                                        href={feathersStore.settings.youtubeUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="social-icon"
                                    >
                                        <YouTubeIcon sx={{ fontSize: 28 }} />
                                    </a>
                                )}
                                {feathersStore.settings?.twitterUrl && (
                                    <a
                                        aria-label="Twitter"
                                        href={feathersStore.settings.twitterUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="social-icon"
                                    >
                                        <TwitterIcon sx={{ fontSize: 28 }} />
                                    </a>
                                )}
                            </div>
                        </div>
                    )}

                    {/* App Download - same gate as the QR section on the home page, so the badges
                        and the codes can never disagree about whether this shop has an app. */}
                    {feathersStore.showAppDownload() && (
                        <div className="footer-app-download">
                            <span className="footer-app-label">App Download:</span>
                            <div className="footer-app-icons">
                                {androidUrl && (
                                    <a href={androidUrl} className="footer-app-icon" target="_blank" rel="noopener noreferrer">
                                        <img height="30" src={googleButton} alt="Google Play Store" loading="lazy" decoding="async" />
                                    </a>
                                )}
                                {urlIos && (
                                    <a href={urlIos} className="footer-app-icon" target="_blank" rel="noopener noreferrer">
                                        <img height="30" src={imageIos} alt="Apple App Store" loading="lazy" decoding="async" />
                                    </a>
                                )}
                            </div>
                        </div>
                    )}
                </div>

                {/* Menu Sections */}
                {!feathersStore.qrReadOnly() && (
                    <>
                        <FooterUsefullMenu />
                        <FooterInfoMenu />
                    </>
                )}
            </footer>

            {/* Arrow Footer - Grey Section - NO GAP */}
            <div className="arrow-footer">
                <ScrollToTopBtn />
            </div>

            {/* Copyright Bar - Dark Grey Section - NO GAP */}
            <div className="copyright">
                {!HIDE_APPDATE ? (
                    <>
                        <div className="copyright-section">
                            <span className="copyright-item">
                                Developed by
                            </span>
                            <a 
                                className="copyright-link" 
                                href="https://www.appdate.gr" 
                                target="_blank" 
                                rel="noopener noreferrer"
                            >
                                AppDate.gr
                                <img src={arrow_appdate} className="arrow-appdate" alt="" loading="lazy" decoding="async" />
                            </a>
                        </div>

                        <div className="copyright-section">
                            <a 
                                className="copyright-link" 
                                href="https://www.bringfood.gr" 
                                target="_blank" 
                                rel="noopener noreferrer"
                            >
                                {footer.installBringFood || ""}
                            </a>
                        </div>

                        <div className="copyright-section">
                            <span className="copyright-item">
                                <CopyrightOutlinedIcon style={{ fontSize: 16, marginRight: 4 }} />
                                <span>BringFood 2014-2025</span>
                                <span className="version">Ver. {feathersStore?.versionNumber || "1.0.56"}</span>
                            </span>
                        </div>
                    </>
                ) : (
                    <div></div>
                )}
            </div>

            {/* Cookies Modal */}
            {feathersStore.showCookies && <CookiesModal />}
        </>
    );
};

export default inject('feathersStore')(observer(Footer));